import React from 'react';

export default function AboutShimmer() {
  return (
    <div className="about-card mx-auto">
      <div className="row align-items-center">
        {/* Avatar Shimmer */}
        <div className="col-md-4 text-center mb-4 mb-md-0">
          <div className="shimmer-circle mx-auto" />
        </div>

        {/* Content Shimmer */}
        <div className="col-md-8">
          <div className="shimmer-line short" />
          <div className="shimmer-line medium" />
          <div className="shimmer-line long mb-4" />

          <div className="row">
            {/* Left column skeleton */}
            <div className="col-sm-6">
              <div className="shimmer-line small mb-2" />
              {[...Array(3)].map((_,i) => (
                <div key={i} className="shimmer-line bullet mb-2" />
              ))}
            </div>

            {/* Right column skeleton */}
            <div className="col-sm-6">
              <div className="shimmer-line small mb-2" />
              {[...Array(3)].map((_,i) => (
                <div key={i} className="shimmer-line bullet mb-2" />
              ))}
            </div>
          </div>

          {/* Button skeleton */}
          <div className="text-center mt-4">
            <div className="shimmer-button mx-auto" />
          </div>
        </div>
      </div>
    </div>
  );
}
